<template>
  <div class="leads">
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>{{ state == 'archived' ? '已归档线索' : '线索' }}</h4>
        <span class="f-s-14 c-m-l-15">管理个人客户和公司客户的线索</span>
      </div>
      <div class="c-flex c-flex-item">
        <el-select
          style="margin-right: 10px"
          width="300px"
          v-model="searchSort"
          placeholder="时间排序"
          clearable
          value-key="index"
          @change="
            fpi.page = 1;
            getData();
          "
        >
          <el-option
            v-for="item in [
              {
                index: 0,
                name: '创建时间降序（最新排最前）',
                sortField: 'createTime',
                sortOrder: 'desc'
              },
              {
                index: 1,
                name: '创建时间升序（最新排最后）',
                sortField: 'createTime',
                sortOrder: 'asc'
              },
              {
                index: 2,
                name: '更新时间降序（最新排最前）',
                sortField: 'updateTime',
                sortOrder: 'desc'
              },
              {
                index: 3,
                name: '更新时间升序（最新排最后）',
                sortField: 'updateTime',
                sortOrder: 'asc'
              }
            ]"
            :key="item.index"
            :label="item.name"
            :value="item"
          ></el-option>
        </el-select>
        <el-input
          placeholder="请输入姓名/手机"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <template v-if="isLeadTag && osg.has('Leads,tag')">
          <el-dropdown class="c-m-l-10" @command="handleMarkTag">
            <el-button type="primary">标记</el-button>
            <el-dropdown-menu slot="dropdown">
              <template v-for="(item, tagIndex) in options['leadTag']">
                <el-dropdown-item :key="tagIndex" :command="item.value">
                  {{ item.label }}
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <el-button v-if="state != 'archived'" type="primary" @click="doNew" class="c-m-l-10">
          新建线索
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'fpi-regex:name|string#or': searchValue,
                'fpi-regex:phone|string#or': searchValue,
                'fpi-regex:email|string#or': searchValue,
                'is:state|integer#and': state == 'archived' ? -1 : 1,
                sortField: searchSort.sortField,
                sortOrder: searchSort.sortOrder,
                beanName: 'lead',
                title: '线索列表'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table" v-if="showList">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-show="refresh && showList && extFields.length"
          @selection-change="selectionChange"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column
            type="selection"
            fixed
            width="55"
            v-if="isLeadTag && osg.has('Leads,tag')"
          ></el-table-column>
          <c-table :fields="extFields">
            <template slot="name">
              <el-table-column label="姓名" width="100" fixed prop="name">
                <template slot-scope="scope">
                  <el-button @click.native.prevent="handleRowClick(scope.row)" type="text">
                    {{ scope.row.name }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="外呼" width="55" fixed v-if="serviceState">
                <template slot-scope="scope">
                  <el-popconfirm
                    confirmButtonText="呼出"
                    cancelButtonText="取消"
                    icon="el-icon-phone"
                    iconColor="#409EFF"
                    hideIcon
                    :title="scope.row.name + ' ' + scope.row.phone"
                    @confirm="callOut(scope.row)"
                    popper-class="c-popconfirm"
                  >
                    <el-button
                      type="primary"
                      icon="el-icon-phone"
                      circle
                      slot="reference"
                    ></el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="osg.has('Leads,archive') && state != 'edit'"
                    @click.native="doEdit(scope.row)"
                    size="mini"
                  >
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('Leads,conver') && state != 'edit'"
                    @click.native="doConver(scope.row)"
                    size="mini"
                  >
                    转为工单
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                    size="mini"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                    size="mini"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('Leads,archive') && state != 'archived'"
                    @click.native="doArchive(scope.row, '归档')"
                    size="mini"
                  >
                    归档
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('Leads?state=archived,recover') && state == 'archived'"
                    @click.native="doArchive(scope.row, '恢复')"
                    size="mini"
                  >
                    恢复
                  </el-dropdown-item>
                  <!-- alloted:'1'表示已分派过 -->
                  <el-dropdown-item
                    v-if="scope.row.exts.alloted != '1'"
                    @click.native="openSR(scope.row)"
                  >
                    手动分派
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="resetExcludeSchedulingPolicy(scope.row._id)">
                    自动分派
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="新增线索"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :options="options"
        @changeForm="osg.changeForm"
        ref="form"
      >
        <!-- <div slot="name">
          <el-input
            v-model="formData['name']"
            type="text"
            placeholder="我是替换的name哦"
          ></el-input>
        </div> -->
        <div slot="phone">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="formData.phone"
            :fetch-suggestions="queryLeadSearch"
            placeholder="请输入手机号"
            @select="handleLeadSelect"
            hide-loading
            value-key="phone"
            style="width: 100%"
          >
            <template slot-scope="{ item }">
              <el-tooltip class="item" effect="dark" placement="right">
                <p class="c-flex c-flex-between">
                  <span class="c-m-r-10">{{ item.name }}</span>
                  <span class="c-m-r-10">{{ item.phone }}</span>
                  <span class="c-m-r-10">
                    {{
                      osg.formatCascade(
                        'LEADSTATUS',
                        Array.isArray(item.leadStatus) ? item.leadStatus[0] : []
                      )
                    }}
                  </span>
                  <span>{{ $util.readableTime(item.createTime, 'date') }}</span>
                </p>
                <div slot="content">
                  <p class="c-flex c-flex-between">
                    <span class="c-m-r-10">{{ item.name }}</span>
                    <span class="c-m-r-10">{{ item.phone }}</span>
                    <span class="c-m-r-10">
                      {{ osg.formatCascade('LEADSTATUS', item.leadStatus) }}
                    </span>
                    <span>{{ item.createTime }}</span>
                  </p>
                </div>
              </el-tooltip>
            </template>
          </el-autocomplete>
        </div>
      </c-form>
      <div slot="footer" style="display: flex; justify-content: space-between">
        <el-button @click="doInit">取 消</el-button>
        <el-button v-if="serviceState" type="primary" @click="doSave(row => callOut(row))">
          保存并拨打电话
        </el-button>
        <el-button type="primary" @click="doSave(null)">保存</el-button>
      </div>
    </el-dialog>

    <!-- <el-dialog title="转为工单" :visible.sync="openDetailSA">
      <el-form
        :model="formDataSA"
        :rules="rules"
        ref="formDataSA"
        label-width="100px"
        label-position="left"
      >
        <el-form-item label="工单标题" prop="title">
          <el-input v-model="formDataSA.title"></el-input>
        </el-form-item>
        <el-form-item label="客户姓名" prop="title">
          <el-input v-model="formDataSA.name"></el-input>
        </el-form-item>
        <el-form-item label="客户手机" prop="phone">
          <el-input v-model="formDataSA.phone"></el-input>
        </el-form-item>
        <el-form-item
          label="省市区"
          prop="area"
          :rules="{
            required: true,
            type: 'array',
            trigger: 'blur',
            message: '省市区不能为空'
          }"
        >
          <el-cascader
            popper-class="cascaderLabelHide-wrapper"
            ref="areaSelectorSA"
            :options="area.options"
            :props="area.props"
            v-model="formDataSA.area"
            clearable
            @change="
              if (formDataSA.subdistrict) {
                formDataSA.subdistrict = '';
              }
              osg.getSubdistricts(formDataSA.area, result => {
                options.subdistricts = result;
                $forceUpdate();
              });
            "
          ></el-cascader>
        </el-form-item>
        <el-form-item label="街道" prop="subdistrict">
          <el-select v-model="formDataSA.subdistrict">
            <el-option
              v-for="item in options.subdistricts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小区" prop="community">
          <el-input v-model="formDataSA.community"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input
            v-model="formDataSA.address"
            suffix-icon="el-icon-map-location"
            @blur="osg.getGeocode()"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="信息渠道"
          prop="channel"
          :rules="{
            required: true,
            type: 'array',
            trigger: 'blur',
            message: '信息渠道不能为空'
          }"
        >
          <el-cascader
            clearable
            v-model="formDataSA.channel"
            :options="options.channel"
            :props="{ label: 'name' }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="预约时间">
          <el-date-picker
            v-model="formDataSA.applyTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formDataSA.status">
            <el-option
              v-for="item in options.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="describe">
          <el-input type="textarea" :rows="1" v-model="formDataSA.describe"></el-input>
        </el-form-item>
        <template v-if="extFieldsSA && extFieldsSA.length">
          <el-form-item
            v-for="(extField, idx) in extFieldsSA"
            :key="idx"
            :label="extField.nameDisp"
          >
            <template
              v-if="
                extField.type == 'text' ||
                  extField.type == 'textarea' ||
                  extField.type == 'number' ||
                  extField.type == 'phone'
              "
            >
              <el-input v-model="formDataSA.exts[extField.name]" :type="extField.type"></el-input>
            </template>
            <template v-if="extField.type == 'radio'">
              <el-radio-group v-model.number="formDataSA.exts[extField.name]">
                <el-radio
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </template>
            <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
              <el-checkbox-group v-model="formDataSA.exts[extField.name]" @change="$forceUpdate()">
                <el-checkbox
                  v-for="item in options[extField.valueOption]"
                  :label="item.value"
                  :key="item.value"
                >
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </template>
            <template v-if="extField.type == 'select'">
              <el-select v-model="formDataSA.exts[extField.name]" placeholder="请选择" clearable>
                <el-option
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
            <template v-if="extField.type == 'cascade'">
              <el-cascader
                clearable
                v-model="formDataSA.exts[extField.name]"
                :options="options[extField.valueOption]"
                :props="{ checkStrictly: true, label: 'name' }"
                @change="$forceUpdate()"
              ></el-cascader>
            </template>
            <template v-if="extField.type == 'date'">
              <el-date-picker
                v-model="formDataSA.exts[extField.name]"
                :type="extField.type"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </template>
            <template v-if="extField.type == 'time'">
              <el-time-select
                v-model="formDataSA.exts[extField.name]"
                :type="extField.type"
                value-format="HH:mm:ss"
                placeholder="选择时间"
              ></el-time-select>
            </template>
            <template v-if="extField.type == 'datetime'">
              <el-date-picker
                v-model="formDataSA.exts[extField.name]"
                :type="extField.type"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
              ></el-date-picker>
            </template>
            <template v-if="extField.type == 'switch'">
              <el-switch
                v-model="formDataSA.exts[extField.name]"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
              ></el-switch>
            </template>
            <template v-if="extField.type == 'rate'">
              <el-rate
                v-model.number="formDataSA.exts[extField.name]"
                @change="$forceUpdate()"
              ></el-rate>
            </template>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSaveSA">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog> -->

    <el-dialog
      title="分派服务资源"
      :visible.sync="SR.show"
      custom-class="c-dialog"
      @close="cancelSR"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="c-flex c-flex-end c_item_start">
        <el-select
          v-model="SR.resourceType"
          multiple
          placeholder="筛选资源类型"
          class="screen"
          clearable
          @clear="
            SR.fpi.page = 1;
            getSR();
          "
          @change="
            SR.fpi.page = 1;
            getSR();
          "
        >
          <el-option
            v-for="item in options.resourceType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="SR.resourceRoles"
          multiple
          placeholder="筛选资源角色"
          class="screen"
          clearable
          @clear="
            SR.fpi.page = 1;
            getSR();
          "
          @change="
            SR.fpi.page = 1;
            getSR();
          "
          style="min-width:200px"
        >
          <el-option
            v-for="item in options.resourceRoles"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          placeholder="请输入资源名称"
          v-model="SR.searchValue"
          class="search-input c-fr"
          clearable
          @clear="
            SR.fpi.page = 1;
            getSR();
          "
          @keyup.enter.native="
            SR.fpi.page = 1;
            getSR();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              SR.fpi.page = 1;
              getSR();
            "
          ></el-button>
        </el-input>
      </div>
      <el-table
        v-loading="SR.loading"
        :data="SR.fpi.data"
        height="100%"
        style="width: 100%; min-height: 440px"
        fit
        header-row-class-name="c-black-dark"
        highlight-current-row
        @current-change="selectSR"
      >
        <el-table-column label="选择" width="50px;">
          <template slot-scope="scope">
            <el-radio v-model="SR.selectId" :label="scope.row._id">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="资源名称"></el-table-column>
        <el-table-column
          prop="resourceType"
          label="资源类型"
          :formatter="formatSRType"
        ></el-table-column>
        <el-table-column label="资源">
          <template slot-scope="scope">
            <template
              v-if="scope.row.resourceType == 'partner' || scope.row.resourceType == 'serviceCrew'"
            >
              {{ formatOrg(scope.row.serviceCrewId) }}
            </template>
            <template v-else>
              {{ formatUser(scope.row.relatedRecordId) }}
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="SR.fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="SR.fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="SR.fpi.total"
        ></el-pagination>
        <div class="c-flex">
          <el-button type="primary" @click="saveSR">确 定</el-button>
          <el-button @click="cancelSR">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
// import areaList from '../../resources/js/areaList.js';
import { mapMutations } from 'vuex';
export default {
  name: 'lead',
  props: {
    serviceState: {
      type: String
    }
  },
  activated() {
    window.$this = this;
  },
  data() {
    window.$this = this;
    return {
      name: 'lead',
      refresh: true,
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: { channel: [] },
      formDataSA: { exts: {} }, //工单表单
      openDetailSA: false, //工单弹窗
      extFieldsSA: [], //工单扩展
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        cascadeCode_channel: { codeId: 'channel' },
        cascadeCode_LEADSTATUS: { codeId: 'LEADSTATUS' },
        codecfg_leadStatus: { codeId: 'LEADSTATUS' },
        codecfg_lifecycleStage: { codeId: 'LIFECYCLESTAGE' },

        //工单
        // codecfg_priority: { codeId: 'PRIORITY' },
        codecfg_stage: { codeId: 'STAGE' },
        codecfg_status: { codeId: 'STATUS' },
        //售后类型细分
        cascadeCode_afterSaleType: { codeId: 'afterSaleType' },
        subdistricts: [],
        codecfg_leadTag: { codeId: 'leadTag' }, //标记
        // 分派
        codecfg_resourceType: { codeId: 'resourceType' },
        codecfg_resourceRoles: {
          codeId: 'resourceRoles'
        },
        ST: [], // 当前页面服务资源关联的服务区域，用作返显服务区域
        org: [], // 当前页面服务资源关联的组织，用作返显资源
        users: [] // 当前页面服务资源关联的人员，用作返显资源
      },
      //地址级联
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      leadSort: null,
      searchSort: null,
      showList: false, //列表展示
      state: '', //已归档 archived
      selectedList: [], //选择列表
      isLeadTag: false, //是否有标记功能,根据有没有配置扩展字段 leadTag判断
      //分单（分服务资源）
      SR: {
        formData: {},
        type: '',
        show: false,
        fpi: {},
        selectRow: {},
        selectId: '',
        searchValue: '',
        resourceType: [], //筛选服务资源类型
        resourceRoles: [], //筛选资源角色
        nodeType: '', //当前节点类型
        loading: false //表格数据加载
      }
    };
  },
  beforeCreate() {
    // window.$this = this;
  },
  async mounted() {
    this.state = this.$route.query.state;
    // 请求工单扩展
    this.doInit();
    // await this.getExtFieldsSA();
    this.osg.getFpi();
    this.osg.ajax(
      'biz/extField/query.do',
      {
        colName: 'lead',
        _all: '1',
        'is:state|integer#and': 1,
        // 'nin:preset|array-integer#and': 1,
        sortField: 'order',
        sortOrder: 'asc'
      },
      res => {
        this.extFields = res.data;
        this.options = this.options || [];
        for (var item of res.data) {
          //解析字段配置
          if (this.$util.isJson(item.frontEndConfig)) {
            item.frontEndConfig = JSON.parse(item.frontEndConfig);
          } else {
            item.frontEndConfig = {};
          }
          //是否有标记功能,根据有没有配置扩展字段 leadTag判断
          if (item.name == 'leadTag') this.isLeadTag = true;
          if (item.valueOption) {
            this.options['codecfg_' + item.valueOption] = {
              codeId: item.valueOption
            };
          }
          //级联
          if (item.type == 'cascade')
            this.options['cascadeCode_' + item.valueOption] = {
              codeId: item.valueOption
            };
        }
        this.osg.codeoption(() => {
          if (JSON.parse(sessionStorage.getItem('leadSort'))) {
            this.searchSort = JSON.parse(sessionStorage.getItem('leadSort'));
          } else {
            this.searchSort = {
              index: 0,
              name: '创建时间降序（最新排最前）',
              sortField: 'createTime',
              sortOrder: 'desc'
            };
          }
          if (this.isLeadTag) this.options['leadTag'].unshift({ label: '取消标记', value: '' });
          this.getData();
        });
      },
      { noload: true }
    );
    if (this.serviceState) {
      if (this.$route.params.searchValue) {
        this.getData(null, this.$route.params.searchValue);
      }
    }
  },
  methods: {
    ...mapMutations(['SetCachedViews']),
    getExtFieldsSA() {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'lead',
          _all: '1',
          'is:state|integer#and': 1,
          'nin:preset|array-integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.extFieldsSA = res.data;
          console.log(this.extFieldsSA);
          this.options = this.options || [];
          for (var item of res.data) {
            //解析字段配置
            if (this.$util.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            } else {
              item.frontEndConfig = {};
            }
            if (item.valueOption) {
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }
        },
        { noload: true }
      );
    },
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    formatProvince(row, column, cellValue) {
      return this.osg.areaObj.province_list[cellValue];
    },
    formatCity(row, column, cellValue) {
      return this.osg.areaObj.city_list[cellValue];
    },
    formatDistrict(row, column, cellValue) {
      return this.osg.areaObj.county_list[cellValue];
    },
    formatState(row, column, cellValue) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatLeadStatus(row, column, cellValue) {
      return this.osg.codelabel('leadStatus', cellValue);
    },
    formatLifecycleStage(row, column, cellValue) {
      return this.osg.codelabel('lifecycleStage', cellValue);
    },
    pageSizeChange(pageSize) {
      if (this.SR.show) {
        this.SR.fpi.rows = pageSize;
        this.getSR();
      } else {
        this.fpi.rows = pageSize;
        this.getData();
      }
    },
    pageChange(currentPage) {
      if (this.SR.show) {
        this.SR.fpi.page = currentPage;
        this.getSR();
      } else {
        this.fpi.page = currentPage;
        this.getData();
      }
    },
    doInit() {
      this.openDetail = false;
      this.openDetailSA = false;
      this.formDataSA = { exts: {} };
      this.formData = { exts: {}, channel: [] };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
      this.state = this.osg.param('state');
    },
    //查询线索
    queryLeadSearch(queryString, cb) {
      if (!queryString) return;
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows || 50,
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name|string#or': queryString,
        'regex:phone|string#or': queryString
      };
      this.osg.ajax(
        'basic/lead/query.do',
        params,
        res => {
          cb(res.data);
        },
        { noload: true }
      );
    },
    //选择线索
    handleLeadSelect(item) {
      // let contactIds = this.formData.contactIds || [];
      // contactIds.push(item._id);
      // this.$set(this.formData, 'contactIds', contactIds);
      this.$set(this.formData, 'name', item.name);
      this.$set(this.formData, 'address', item.address);
    },
    getData(callback, searchValue) {
      if (this.searchSort) sessionStorage.setItem('leadSort', JSON.stringify(this.searchSort));
      this.showList = false; //列表显示
      if (searchValue) this.searchValue = searchValue;
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows || 50,
        'in:state|array-integer#and': this.state == 'archived' ? -1 : '0,1',
        'exists:name|boolean#and': true,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:email|string#or': this.searchValue,
        sortField: this.searchSort && this.searchSort.sortField,
        sortOrder: this.searchSort && this.searchSort.sortOrder
      };
      //添加过滤器参数
      $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/lead/query.do', params, res => {
        this.fpi = res;
        this.showList = true; //列表显示
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
          this.$forceUpdate();
          if (callback) callback(res);
        });
      });
    },
    doNew() {
      this.doInit();
      this.$set(this.formData, 'leadStatus', ['0']);
      this.$set(this.formData, 'customTime', this.$util.readableTime());
      this.openDetail = true;
    },
    doEdit(row) {
      var row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
      this.osg.getSubdistricts(this.formData.area, result => {
        this.options.subdistricts = result;
        this.$forceUpdate();
      });
    },
    //转工单操作按钮
    doConver(row) {
      var row = this.$util.deepCopy(row);
      this.openDetailSA = true;
      this.formDataSA = {
        contactIds: [row._id],
        name: row.name,
        address: row.address,
        area: row.area,
        belongTo: row.belongTo,
        province: row.province,
        city: row.city,
        district: row.district,
        phone: row.phone,
        exts: {},
        leadIds: [row._id]
      };
      console.log(this.formDataSA);
    },
    doSave(callback) {
      if (this.osg.isRepeatClick('saveRecord', 5000)) {
        return;
      }
      if (this.osg.validate()) {
        // 赋值省市区
        this.formData.area = this.formData.area || [];
        this.formData.province = this.formData.area[0] || '';
        this.formData.city = this.formData.area[1] || '';
        this.formData.district = this.formData.area[2] || '';
        this.osg.ajax('basic/lead/upsert.do', { data: JSON.stringify(this.formData) }, res => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
          console.log(callback);
          if (callback) callback(res.data);
        });
      }
    },
    doSaveSA() {
      if (this.osg.validate('formDataSA')) {
        var params = this.formDataSA;
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
            }
          }
        }
        // delete params.area;
        this.osg.ajax(
          'basic/serviceAppointment/upsert.do',
          { data: JSON.stringify(params) },
          () => {
            this.doInit();
            this.getData();
            // this.osg.confirm('保存成功！需要跳转到工单吗？', () => {
            //   this.$router.push({ path: '/ServiceAppointments' });
            // });
            this.osg.toast('操作成功！');
          }
        );
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/lead/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/lead/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doArchive(row, msg) {
      this.osg.confirm(`是否确认${msg}线索 ${row.name}？`, () => {
        this.osg.ajax('basic/lead/archive/' + row._id + '.do', null, () => {
          this.getData();
          this.osg.toast(`已${msg}线索 ${row.name}`);
        });
      });
    },
    //选择线索
    selectionChange(rows) {
      this.selectedList = rows;
    },
    //标记
    handleMarkTag(command) {
      let ids = this.selectedList.map(item => item._id);
      this.osg.confirm('确定标记这些吗？', () => {
        this.markTagAjax(
          JSON.stringify({
            bizType: 'Lead',
            codeType: 'leadTag',
            codeValue: command,
            ids
          })
        );
      });
    },
    //调用标记接口
    markTagAjax(param) {
      this.osg.ajax(
        '/basic/lead/tagBeanHandler.do',
        { param },
        () => {
          this.selectedList = [];
          this.getData();
          this.osg.toast('操作成功！');
        },
        {
          fail: () => {
            this.selectedList = [];
            this.getData();
          }
        }
      );
    },
    /**
     * 外呼
     */
    callOut(row) {
      // this.$router.push({ path: `/Lead/${row._id}`, query: { isCall: true } });
      this.$router.push({
        name: 'Lead',
        params: { id: row._id, isCall: true }
      });

      // 调用外呼接口-传外呼号码
      // this.osg.sobot.callOut({
      //   destinationNumber: row.phone,
      //   params: `{ "bizType": "Lead", "bizId":"${row._id}"}`
      // });
    },
    //展示分配服务资源
    openSR(row) {
      this.SR.formData = row;
      //获取服务资源
      this.getSR();
      this.SR.show = true;
      this.SR.loading = true;
    },
    //获取服务资源
    getSR() {
      let params = {
        page: this.SR.fpi.page || 1,
        rows: this.SR.fpi.rows || 20,
        'in:state|array-integer#and': '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name|string#and': this.SR.searchValue,
        'in:resourceType|array#and': this.SR.resourceType && this.SR.resourceType.join(),
        'in:resourceRoles|array#and': this.SR.resourceRoles && this.SR.resourceRoles.join(),
        'is:serviceType|string#and': this.SR.formData.serviceType
      };
      this.osg.ajax(
        'biz/serviceResource/query.do',
        params,
        async res => {
          //收集服务资源id、组织id、用户id
          let SRIds = [];
          let orgIds = [];
          let userIds = [];
          res.data.map(item => {
            SRIds.push(item._id);
            if (item.resourceType == 'partner' || item.resourceType == 'serviceCrew') {
              //伙伴、班组
              orgIds.push(item.serviceCrewId);
            } else {
              //technician技师、dispatcher派单员
              userIds.push(item.relatedRecordId);
            }
          });

          //获取服务区域、组织、用户 用作返显服务区域和资源名称
          if (SRIds.length > 0) {
            if (orgIds.length > 0) {
              await new Promise(resolve => {
                this.getOrgs(orgIds, resolve);
              });
            }
            if (userIds.length > 0) {
              await new Promise(resolve => {
                this.getUsers(userIds, resolve);
              });
            }
          }
          this.SR.fpi = res;
          this.SR.loading = false;
        },
        {
          noload: true
        }
      );
    },
    selectSR(row) {
      if (row) {
        this.SR.selectRow = row;
        this.SR.selectId = row._id;
      }
    },
    saveSR() {
      if (!this.SR.selectId) {
        this.osg.toast('请选择服务资源！', 'warning');
        return;
      }
      //撤回单
      this.osg.confirm(`是否确认分派给 ${this.SR.selectRow.name}`, () => {
        this.osg.ajax(
          'basic/lead/allot.do',
          { id: this.SR.formData._id, bizId: this.SR.selectRow._id },
          () => {
            this.getData();
            this.cancelSR();
            this.osg.toast('分派成功');
          }
        );
      });
    },
    cancelSR() {
      this.SR.show = false;
      this.SR.formData = {};
      this.SR.selectRow = {};
      this.SR.selectId = '';
      this.SR.searchValue = '';
      this.SR.resourceType = []; //筛选服务资源类型
      this.SR.resourceRoles = []; //筛选资源角色
    },
    //获取组织
    getOrgs(orgIds, resolve) {
      this.osg.ajax(
        'org/query.do',
        {
          page: 1,
          rows: orgIds.length,
          'in:_id|array#and': orgIds.join()
        },
        res => {
          res.data.orgList.map(item => {
            item.label = item.orgName;
            item.value = item._id;
          });
          this.options.org = res.data.orgList;
          resolve();
        },
        {
          noload: true
        }
      );
    },
    // 服务资源列表返显用户名称
    getUsers(userIds, resolve) {
      this.osg.ajax(
        'user/query.do',
        {
          page: 1,
          rows: userIds.length,
          'in:_id|array#and': userIds && userIds.join()
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.users = res.data;
          resolve();
        },
        {
          noload: true
        }
      );
    },
    formatSRType(row, column, cellValue) {
      return this.osg.codelabel('resourceType', cellValue);
    },
    formatOrg(cellValue) {
      return this.osg.codelabel('org', cellValue);
    },
    formatUser(cellValue) {
      return this.osg.codelabel('users', cellValue);
    },
    handleRowClick(row) {
      console.log('个别页面', row);
      this.$router.push({
        path: `/Lead/${row._id}`
      });
      this.SetCachedViews({ params: row.name, action: `/Lead/${row._id}` });
    },
    resetExcludeSchedulingPolicy(id) {
      this.osg.confirm('未分派的线索将会根据调度策略自动分派', () => {
        this.osg.ajax('basic/scheduler/resetExcludeSchedulingPolicy.do', { id }, () => {
          this.osg.toast('操作成功');
        });
      });
    }
  },
  watch: {
    $route() {
      // window.$this = this;
      // this.state = this.$route.query.state;
      // this.searchValue = ''; //切换页面清空过滤
      // this.fpi.page = 1;
      // this.doInit();
      // if (this.serviceState) {
      //   if (this.$route.params.searchValue) {
      //     this.getData(null, this.$route.params.searchValue);
      //   } else {
      //     this.osg.getFpi();
      //   }
      // } else {
      //   this.getData(null, this.$route.params.searchValue);
      // }
    },
    //area 级联组件点击label就消失
    'formData.area'() {
      if (this.$refs.areaSelector) {
        this.$refs.areaSelector.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    'formDataSA.area'() {
      if (this.$refs.areaSelectorSA) {
        this.$refs.areaSelectorSA.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    //信息渠道,级联组件点击label就消失
    'formData.channel'() {
      if (this.$refs.channelCascader) {
        this.$refs.channelCascader.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    //线索状态,级联组件点击label就消失
    'formData.leadStatus'() {
      if (this.$refs.leadStatusCascader) {
        this.$refs.leadStatusCascader.dropDownVisible = false; //监听值发生变化就关闭它
      }
    }
  }
};
</script>

<style lang="scss">
/* 处理input type = number的上下箭头 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
.leads {
  .c-dialog {
    min-width: 800px !important;
  }
}
</style>
